module.exports = __webpack_public_path__ + "img/template03.05da080f.png";